/* ==========================================================================
   FORGED GOLF — THEME SCRIPTS
   Vanilla JS. No dependencies. Progressive enhancement only.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile nav drawer ---------- */
  var mobileNav = document.querySelector('[data-mobile-nav]');
  document.querySelectorAll('[data-mobile-nav-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mobileNav) mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
  document.querySelectorAll('[data-mobile-nav-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mobileNav) mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  /* ---------- Search popover ---------- */
  var searchPopover = document.querySelector('[data-search-popover]');
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchPopover) {
        searchPopover.classList.add('is-open');
        var input = searchPopover.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 300);
      }
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchPopover) searchPopover.classList.remove('is-open');
    });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', openCart);
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });

  /* Intercept product-form submissions to add via AJAX and open the drawer */
  document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var settingEl = document.querySelector('[data-cart-drawer]');
      if (!settingEl) return; // fall back to native submit -> /cart/add redirect
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[data-add-to-cart]');
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          openCart();
          // Best-effort refresh; a full theme would re-render drawer items via section rendering API.
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submitBtn) submitBtn.removeAttribute('disabled');
        });
    });
  });

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  /* ---------- Product variant selection (color / size) ---------- */
  var variantSelect = document.querySelector('[data-variant-select]');

  document.querySelectorAll('.swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      document.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('is-active'); });
      swatch.classList.add('is-active');
      syncVariant();
    });
  });

  document.querySelectorAll('.size-box').forEach(function (box) {
    box.addEventListener('click', function () {
      if (box.hasAttribute('disabled')) return;
      document.querySelectorAll('.size-box').forEach(function (s) { s.classList.remove('is-active'); });
      box.classList.add('is-active');
      syncVariant();
    });
  });

  function syncVariant() {
    if (!variantSelect) return;
    var selectedValues = [];
    var activeSwatch = document.querySelector('.swatch.is-active');
    var activeSize = document.querySelector('.size-box.is-active');
    if (activeSwatch) selectedValues.push(activeSwatch.getAttribute('data-value'));
    if (activeSize) selectedValues.push(activeSize.getAttribute('data-value'));

    var options = Array.prototype.slice.call(variantSelect.options);
    var match = options.find(function (opt) {
      var title = opt.textContent.trim();
      return selectedValues.every(function (v) { return title.indexOf(v) !== -1; });
    });
    if (match) {
      variantSelect.value = match.value;
      var addBtn = document.querySelector('[data-add-to-cart]');
      if (addBtn) {
        if (match.disabled) {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = 'Sold Out';
        } else {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = 'Add to Bag';
        }
      }
    }
  }

  /* ---------- Product gallery thumbnails + zoom ---------- */
  var mainImage = document.getElementById('ProductMainImage');
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImage) mainImage.setAttribute('src', thumb.getAttribute('data-full'));
    });
  });

  document.querySelectorAll('[data-zoom]').forEach(function (zoomEl) {
    zoomEl.addEventListener('click', function () {
      zoomEl.classList.toggle('is-zoomed');
    });
  });

  /* ---------- Product accordion ---------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.accordion-item');
      var panel = item.querySelector('[data-accordion-panel]');
      var isOpen = item.classList.contains('is-open');

      item.parentElement.querySelectorAll('.accordion-item').forEach(function (el) {
        el.classList.remove('is-open');
        el.querySelector('[data-accordion-panel]').style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
  // Open first accordion panel by default
  document.querySelectorAll('.accordion-item.is-open [data-accordion-panel]').forEach(function (panel) {
    panel.style.maxHeight = panel.scrollHeight + 'px';
  });

  /* ---------- Cart page quantity updates ---------- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      input.closest('form').submit();
    });
  });

  /* ---------- Scroll-triggered fade-ups ---------- */
  var fadeEls = document.querySelectorAll('.fade-up');
  if ('IntersectionObserver' in window && fadeEls.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    fadeEls.forEach(function (el) { observer.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Header shadow on scroll ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 4) {
        header.style.boxShadow = '0 1px 0 rgba(255,255,255,0.08)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

});
